// Centralized media assets for DaniQ — real photos supplied by the artist.
export const IMAGES = {
  heroDaniq: "/media/hero.jpg",
  aboutDrummer: "/media/about-drummer.jpg",
  experienceFestival: "/media/festival.jpg",
  experienceLounge: "/media/lounge.jpg",
  producerHero: "/media/studio.jpg",
  galleryPortrait: "/media/portrait-bw.jpg",
  galleryHandsDrums: "/media/drums-bw.jpg",
  ctaTexture: "/media/lasers.jpg",
  // extras for gallery variety
  branded: "/media/branded.jpg",
  decks: "/media/decks.jpg",
  mcGold: "/media/mc-gold.jpg",
  drumSmile: "/media/drum-smile.jpg",
  escapeNeon: "/media/escape-neon.jpg",
};

// Hero background video (drummer loop). Leave empty ("") to fall back to the hero photo.
export const HERO_VIDEO = "/media/video/hero.mp4";
export const HERO_VIDEO_WEBM = "/media/video/hero.webm";

// Royalty-free placeholder ambient track
export const AUDIO_TRACK = "/media/audio/ambient.mp3";
